import * as reducers from './reducers';

const lite = { reducers };
export default lite;
